const appErrorBoundaryLang = {
	public_title: {
		tag: 'app.error_boundary.public_title',
		fr: 'Désolé... il y a eu une erreur',
		en: 'Sorry... there was an error',
	},
	public_description: {
		tag: 'app.error_boundary.public_description',
		fr: 'Une erreur est survenue sur la page, les équipes techniques ont été mises au courant de la situation et devraient résoudre ce problème dans les meilleurs délais.',
		en: 'An error has occurred on the page, the technical teams have been made aware of the situation and should resolve the issue as soon as possible.',
	},
};

export default appErrorBoundaryLang;
